export const debounce = (fn, delay) => {
    let timeoutID = null;

    return function () {
        const args = arguments;
        const context = this;

        clearTimeout(timeoutID);
        timeoutID = setTimeout(() => {
            fn.apply(context, args);
        }, delay);
    };
};

export const throttle = (fn, limit) => {
    let throttling;

    return function () {
        const args = arguments;
        const context = this;

        if (!throttling) {
            fn.apply(context, args);
            throttling = true;
            setTimeout(() => throttling = false, limit);
        }
    };
};
